import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "../../components/Container";
import Navbar from "../../components/Navbar";
import QuizzesList from "../../components/Quizzes/QuizzesList";
export default function Quizzes() {
  useEffect(() => {
    document.title = "Quizzes";
  });
  return (
    <>
      <Navbar />
      <Container>
        <div className="px-3 py-20 bg-opacity-10">
          <h2 className="text-4xl text-center ">Quizzes</h2>

          <div className="w-full flex">
            <Link to="/admin/addQuiz" className="btn ml-auto">
              Add Quiz
            </Link>
          </div>
          <div className="overflow-x-auto mt-4">
            <QuizzesList />
          </div>
        </div>
      </Container>
    </>
  );
}
